import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import React from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import { FiChevronRight, FiLock, FiLogOut, FiUser } from 'react-icons/fi'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { submit } from 'redux-form'
import Flex from 'typescript-styled-flex'
import { signOffFromSession } from '../../../../../actions/userAccount/authorize/unauthorize'
import Button from '../../../../../components/Template/Button'
import { IStore } from '../../../../../reducers'
import { getUsername } from '../../../../../reducers/userAccount/selectors/userAccount'
import { theme } from '../../../../../theme'
import ChangePassword from '../../../../Form/ChangePassword'
import ButtonLabel from '../../Menu/AccountOptions/ButtonLabel'
import SecondaryTypography from '../components/SecondaryTypography'
import Typography from '../components/Typography'
import UsernameLabel from '../components/UsernameLabel'
import Sidebar from '../Sidebar'

function AccountMenu({
  name,
  t,
  onReset,
  onLogout,
}: IAccountMenu & WithTranslation & IAccountMenuDispatch) {
  const [open, setOpen] = React.useState(false)
  const [openPassword, setOpenPassword] = React.useState(false)

  function toggleOpen() {
    setOpen(!open)
  }

  function toggleToPassword() {
    setOpenPassword(!openPassword)
  }

  return (
    <React.Fragment>
      <ListItem
        button={true}
        style={{ maxHeight: '60px', minHeight: '60px', minWidth: '30px' }}
        onClick={toggleOpen}
      >
        <ListItemIcon style={{ minWidth: '30px' }}>
          <FiUser size={20} />
        </ListItemIcon>
        <ListItemText
          primary={<Typography>{t('BBO_936_my_account')}</Typography>}
          secondary={<SecondaryTypography>{name}</SecondaryTypography>}
        />
        <FiChevronRight />
      </ListItem>

      <Sidebar
        closeDrawer={toggleOpen}
        open={open}
        headerIcon={
          <FiUser
            color={theme.colors.palette.greyishBrown}
            size={20}
            style={{ minHeight: 20, minWidth: 20 }}
          />
        }
        headerLabel={t('BBO_936_my_account')}
        elevation={0}
        scrollable={true}
      >
        <Flex
          alignCenter={true}
          column={true}
          style={{ marginTop: '15px', width: '100%' }}
        >
          <Flex
            alignCenter={true}
            justifyCenter={true}
            column={true}
            style={{ padding: '0px 20px', width: '100%' }}
          >
            <Flex
              alignCenter={true}
              justifyCenter={true}
              style={{
                backgroundColor: theme.colors.palette.paleGrey,
                borderRadius: '50%',
                height: '48px',
                marginBottom: '10px',
                width: '48px',
              }}
            >
              <FiUser size={25} />
            </Flex>
          </Flex>
          <span style={{ fontSize: '14px' }}>
            <Trans i18nKey={'email'} />
          </span>
          <UsernameLabel>{name}</UsernameLabel>
          <Divider style={{ margin: '15px 0px', width: '100%' }} />
          <Flex
            alignCenter={true}
            justifyCenter={true}
            column={true}
            style={{ padding: '0px 20px', width: '100%' }}
          >
            <Button
              style={{ marginBottom: '10px', width: '100%' }}
              onClick={toggleToPassword}
            >
              <ButtonLabel>
                <Trans i18nKey={'reset_password'} />
              </ButtonLabel>
            </Button>
            <Button style={{ width: '100%' }} logout={true} onClick={onLogout}>
              <FiLogOut color={'white'} />
              <ButtonLabel>
                <Trans i18nKey={'logout'} />
              </ButtonLabel>
            </Button>
          </Flex>
        </Flex>
      </Sidebar>
      <Sidebar
        closeDrawer={toggleToPassword}
        open={openPassword}
        headerIcon={
          <FiLock
            color={theme.colors.palette.greyishBrown}
            size={20}
            style={{ minHeight: 20, minWidth: 20 }}
          />
        }
        headerLabel={t('BBO_936_change_password')}
        elevation={0}
        scrollable={true}
      >
        <Flex
          style={{ marginTop: '15px', padding: '0px 20px', width: '100%' }}
          column={true}
        >
          <ChangePassword />
          <Button
            style={{ marginTop: '20px', width: '100%' }}
            primary={true}
            onClick={onReset}
          >
            <ButtonLabel>
              <Trans i18nKey={'save'} />
            </ButtonLabel>
          </Button>
        </Flex>
      </Sidebar>
    </React.Fragment>
  )
}

const mapStateToProps = (state: IStore): IAccountMenu => ({
  name: getUsername(state),
})

const bindDispatchToProps = (dispatch: Dispatch): IAccountMenuDispatch => ({
  onLogout() {
    dispatch(signOffFromSession())
  },
  onReset() {
    dispatch(submit('changePassword'))
  },
})

export default withTranslation()(
  connect(
    mapStateToProps,
    bindDispatchToProps,
  )(AccountMenu) as any,
)as any

export interface IAccountMenu {
  name?: string
}

export interface IAccountMenuDispatch {
  onLogout?: () => void
  onReset?: () => void
}
